import React from "react";
import Lottie from "react-lottie";
import dashboardAnimation from "assets/images/landing-page/dashboard.json";
import approvalAnimation from "assets/images/landing-page/approvals.json";
import workOrderAnimation from "assets/images/landing-page/document.json";
import inventoryAnimation from "assets/images/landing-page/warehouse.json";

function AppShowcase() {
  const showcaseItems = [
    {
      title: "Sales Dashboard",
      description:
        "Real-time overview of your sales pipeline, quotes, and work orders.",
      lottie: dashboardAnimation,
      features: [
        "Location-aware job board filters",
        "Job / Ready-to-Bill / Pending tabs",
        "Product-type dashboards with live search",
      ],
      position: "left",
    },
    {
      title: "Work Order Management",
      description:
        "Complete work order lifecycle from creation to delivery with approval workflows.",
      lottie: workOrderAnimation,
      features: [
        "Status filters with search & pagination",
        "Quick view of work order products",
        "One-click Excel exports",
      ],
      position: "right",
    },

    {
      title: "Approval System",
      description:
        "Unified lot approvals for work orders, shipping, and Excel artifacts with clear audit trails.",
      lottie: approvalAnimation,
      features: [
        "Approve / reject / approve-with-changes with comments",
        "Shipping, billing, and Excel file approvals with downloads",
        "Combined status filters, bulk refresh, and lock-on-complete",
      ],
      position: "left",
    },
    {
      title: "Inventory Tracking",
      description:
        "Comprehensive material stock management with purchase orders and vendor management.",
      lottie: inventoryAnimation,
      features: [
        "Unified stock, purchase, and issue history",
        "Location-aware material balances",
        "Excel-ready exports for audits",
      ],
      position: "right",
    },
  ];

  return (
    <section className="py-5 bg-white">
      <div className="container">
        <div className="row mb-5">
          <div className="col-12 text-center animate-on-scroll">
            <h1 className="display-5 fw-bold">
              <i className="mdi mdi-monitor-dashboard text-primary"></i>
            </h1>
            <h2 className="fw-bold">
              See <span className="text-primary">Sportswear ERP</span> in Action
            </h2>
            <p className="text-muted lead mt-3">
              Powerful features designed specifically for sportswear
              manufacturing businesses
            </p>
          </div>
        </div>

        {showcaseItems.map((item, index) => (
          <div
            key={index}
            className={`row align-items-center pb-5 animate-on-scroll ${
              item.position === "right" ? "flex-row-reverse" : ""
            }`}
            style={{ animationDelay: `${index * 0.2}s` }}
          >
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div
                className={
                  item.position === "left" ? "slide-in-left" : "slide-in-right"
                }
              >
                {item.lottie ? (
                  <Lottie
                    options={{
                      loop: true,
                      autoplay: true,
                      animationData: item.lottie,
                      rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice",
                      },
                    }}
                    height={400}
                    width={400}
                  />
                ) : (
                  <img
                    src={item.image}
                    alt={item.title}
                    className="img-fluid rounded shadow-lg"
                    style={{ width: "100%", height: "auto" }}
                  />
                )}
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className={`${
                  item.position === "right" ? "pe-lg-5" : "ps-lg-5"
                }`}
              >
                <h3 className="fw-bold mb-3">{item.title}</h3>
                <p className="text-muted lead">{item.description}</p>
                <ul className="list-unstyled mt-4">
                  {(item.features || []).map((feature, featureIndex) => (
                    <li className="mb-2" key={featureIndex}>
                      <i className="mdi mdi-check-circle text-success me-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default AppShowcase;
